import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios'
import fileDownload from "js-file-download";
import { Mutation } from 'react-apollo';
import { PORTAL_REFRESH_TOKEN } from '../graphql'


const HeaderOriginal = ({ protocol, finished, order }) => {
}

class Header extends React.Component {
  constructor(props) {
    super(props);
  }

  async downloadReceipts(protocol, refresh_token) {
    let token = await refresh_token()
    let headers = {
      "Authorization": `JWT ${token.data.refreshToken.token}`
    }

    let baseURL = 'https://api.usezapay.com.br';

    if (process.env.NODE_ENV === 'development') {
      baseURL = 'http://localhost';
    }

    console.log(baseURL)

    let response = await axios.get(
      baseURL + `/portal/reports/receipts/?protocol=${protocol}`,
      { headers: headers }
    )

    console.log(response)
    let files = response.data
    for (let file of files) {
      window.open(file.url)
    }

  }

  render() {

    const { protocol, finished, order } = this.props
    const token = sessionStorage.token;
    const variables = {
      token
    }

    return (
      <div className="header bg-gradient-danger py-6">
        <div className="container-fluid">
          <div className="header-body">
            <div className="row align-items-center py-4">
              <div className="col-lg-6 col-5">
                <h6 className="h2 text-white d-inline-block mb-0">Venda {protocol}</h6>
              </div>
              <div className="col-lg-6 col-5 text-right">
                {finished &&
                  <Link
                    to={{
                      pathname: '/termo',
                      state: {
                        protocol: protocol,
                        customer: order.customer,
                        createdAt: order.createdAt,
                        baseAmount: order.baseAmount,
                        totalAmount: order.totalAmount,
                        payments: order.payments,
                        orderItems: order.orderItems,
                        orderOrigin: order.orderOrigin,
                        orderState: order.orderState,
                        promotionalTicket: order.promotionalTicket

                      }
                    }}
                    className="btn btn-sm btn-default">Termo de Ciência
                  </Link>
                }

                {finished &&
                  <a href={`https://b2b.usezapay.com.br/comprovante/${protocol}`} rel="noopener" target="_blank" className="btn btn-sm btn-default">Comprovante Zapay</a>
                }
                {finished &&
                  <Mutation
                    mutation={PORTAL_REFRESH_TOKEN}
                    variables={variables}
                  >
                    {(refresh_token) => {
                      return (
                        <button
                          className="btn btn-sm btn-default"
                          onClick={() => this.downloadReceipts(protocol, refresh_token)}
                        >
                          Comprovante Bancário
                        </button>
                      )
                    }}
                  </Mutation>
                }
                {/* <a href="#" className="btn btn-sm btn-danger">Cancelar</a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Header.js